import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseDateTimeService {
  abstract useMilitaryTime(): Observable<boolean>;
  abstract formatDateTime(date: Date | null | undefined): Observable<string>;
  abstract formatDate(date: Date | null | undefined): Observable<string>;
}
